import React from 'react';
import { Form } from "react-final-form";
import { changePasswordConfig, loginConfig } from "../config";
import { Button, Flex, Input, Text } from "@chakra-ui/react";
import { FormField, SubmitButton } from "../../../components/form";
import { useRef, useEffect, useState } from 'react';
import { FormApi } from "final-form";
import { LoginPropTypes } from "../PayRentPropTypes";
import { localisable } from "../../../generic/localisable";
import { emailFormButtonProps, formMainContainerCommonProps, submitButtonProps } from "../constants";
import { displayLoader, renderErrorContainer } from "../Utils";
import { navigate } from "gatsby-link";



export const ChangePasswordLoginForm = ({ onSubmitCpLoginForm }: LoginPropTypes.TForgotPasswordProps) => {

    const formProps = useRef({});
    const { userName, password } = loginConfig();
    const [isLoading, setIsLoading] = useState(false);

    const onSubmit = (form: FormApi) => {
        setIsLoading(true);
        onSubmitCpLoginForm(form, setIsLoading);
    }

    const renderForm = (currentFormProps: any) => {

        return (
            <Flex direction='column' gap='24px' w={{ base: '100%', md: 'max(36%, 318px)' }} >
                {isLoading ?
                    <Flex minHeight={'250px'}>
                        {displayLoader()}
                    </Flex>
                    :
                    <>
                        <FormField {...userName} {...currentFormProps}>
                            <Input />
                        </FormField>
                        <FormField {...password} {...currentFormProps}>
                            <Input />
                        </FormField>
                        <SubmitButton
                            label={localisable.login}
                            formProps={currentFormProps}
                            {...submitButtonProps}
                        />
                    </>
                }
            </Flex>
        )
    }

    return (
        <Flex w={{ base: '100%', md: 'max(36%, 318px)' }} direction='column' gap='24px'>
            <Form
                onSubmit={onSubmit}
                initialValues={{ userName: '', password: '' }}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {renderForm(currentFormProps)}
                        </form>
                    )
                }}
            />
        </Flex>
    )
};


export const ChangePasswordForm = ({ changePasswordError, onSubmitChangePasswordForm }: LoginPropTypes.TChangePasswordFormProps) => {

    const formProps = useRef({});
    const { oldPassword, newPassword, reEnterNewPassword } = changePasswordConfig();
    const [isChangePasswordErrorExists, setIsChangePasswordErrorExists] = useState(false);

    useEffect(() => {
        if (changePasswordError) {
            setIsChangePasswordErrorExists(true);
        }
    }, [changePasswordError]);

    const onSubmit = (form: FormApi) => {
        onSubmitChangePasswordForm(form);
    }

    const renderForm = (currentFormProps: any) => {

        return (
            <Flex direction='column' gap='24px' justifyContent='center'>
                <FormField {...oldPassword} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...newPassword} {...currentFormProps} >
                    <Input />
                </FormField>
                <FormField {...reEnterNewPassword} {...currentFormProps} >
                    <Input />
                </FormField>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                    <Button
                        {...emailFormButtonProps}
                        onClick={() => navigate(-1)}
                        bg='button.blue'
                        minW={{ base: '100%', sm: '204px' }}
                    >
                        <Text textStyle='buttonSmall' color='common.white' >{localisable.goBack}</Text>
                    </Button>
                    <SubmitButton
                        formProps={currentFormProps}
                        label={localisable.change}
                        {...emailFormButtonProps}
                        minW={{ base: '100%', sm: '204px' }}
                    />
                </Flex>
            </Flex>
        )
    }

    return (
        <Flex direction='column' {...formMainContainerCommonProps}>
            {isChangePasswordErrorExists && renderErrorContainer(changePasswordError, setIsChangePasswordErrorExists)}
            <Form
                onSubmit={onSubmit}
                initialValues={{ oldPassword: '', newPassword: '', reEnterNewPassword: '' }}
                render={(currentFormProps) => {
                    const { handleSubmit, ...restFormProps } = currentFormProps;
                    formProps.current = restFormProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            {renderForm(currentFormProps)}
                        </form>
                    )
                }}
            />
        </Flex>
    )
};


export const SuccessComponent = ({ note, customerNote, goToPaymentHandler }: LoginPropTypes.TPasswordResetSuccessProps) => {


    return (
        <Flex direction='column' {...formMainContainerCommonProps}>
            <Flex direction='column' gap='8px' pt='16px'>
                <Text textStyle='subtitle' fontStyle='italic'>{note}</Text>
                <Text textStyle='subtitle' fontStyle='italic'>{customerNote}</Text>
            </Flex>
            <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                <Button
                    {...emailFormButtonProps}
                    onClick={() => navigate(-1)}
                    bg='button.blue'
                    minW={{ base: '100%', sm: '204px' }}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.goBack}</Text>
                </Button>
                <Button
                    {...emailFormButtonProps}
                    onClick={goToPaymentHandler}
                    bg='button.blue'
                    minW={{ base: '100%', sm: '204px' }}
                >
                    <Text textStyle='buttonSmall' color='common.white' >{localisable.goToPayment}</Text>
                </Button>
            </Flex>
        </Flex>
    )
}